import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import {
  useVolumesFilterActions,
  useVolumesFilterState,
} from '@paradigm/features/src/leaderboard/contexts/volumes-filter';
import { TabContainer } from '#/components/Leaderboard/shared/components';
import FilterModal from '#/components/Leaderboard/shared/FilterModal';
import FilterForm from '#/components/Leaderboard/shared/FilterForm';
import MobileTabHeader from '#/components/Leaderboard/shared/MobileTabHeader';
import { useVolumesListState } from '@paradigm/features/src/leaderboard/contexts/volumes-list';
import VolumeTable from './table/VolumeTable';
import MobileMenuSection from './MobileMenuSection';

export default function LeaderboardVolumeTab() {
  const isMobile = useIsMobile();
  const actions = useVolumesFilterActions();
  const state = useVolumesFilterState();
  const { lastUpdatedAt } = useVolumesListState();
  return (
    <TabContainer data-testid="leaderboard-volume-tab">
      {isMobile ? (
        <>
          <MobileTabHeader filterState={state} />
          <MobileMenuSection />
        </>
      ) : (
        <FilterForm
          lastUpdatedAt={lastUpdatedAt}
          actions={actions}
          state={state}
          filterType="volumes"
        />
      )}
      <VolumeTable />
      <FilterModal
        lastUpdatedAt={lastUpdatedAt}
        actions={actions}
        state={state}
        filterType="volumes"
      />
    </TabContainer>
  );
}
